<ng-content />
<app-ice-icon-button
  class="close-icon"
  matDialogClose
  size="32px"
  testId="equipment-cancel-button"
  [iconName]="IconNames.ice_close"
  (clicked)="closeDialog.emit()"
/>
